<template>
  <ul
    id="pagination"
    class="cN-pagination"
  >
    <li
      v-if="cur > 1"
      class="prev"
    ><a
        href="javascript:;"
        rel="prev"
        @click="btnClick(1)"
      >首页</a></li>
    <li
      v-if="cur > 1"
      class="prev"
    ><a
        href="javascript:;"
        rel="prev"
        @click="prevPage"
      >« 上一页</a></li>

    <li
      v-for="index in indexs"
      v-bind:key="index"
      v-bind:class="{ selected: cur == index}"
    >
      <a
        v-if="cur != index"
        v-on:click="btnClick(index)"
      >{{ index }}</a>
      {{ index == cur ? cur : '' }}
    </li>

    <li
      v-if="cur < all"
      class="next"
    ><a
        href="javascript:;"
        rel="prev"
        @click="nextPage"
      >下一页 »</a></li>
    <li
      v-if="cur < all"
      class="next"
    ><a
        href="javascript:;"
        rel="prev"
        @click="btnClick(all)"
      >尾页</a></li>
    <li class="topage">
      到第<input
        class=""
        type="number"
        v-model="pageIndex"
      >页 <span @click="goPage(pageIndex)">确定</span>
    </li>
    <li><span class="page_total">共<b>{{ totalData }}</b>条</span></li>
  </ul>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    cur: {
      type: [String, Number],
      required: true
    },
    all: {
      type: [String, Number],
      required: true
    },
    totalData: {
      type: [String, Number],
      required: true
    },
    callback: {
      default() {
        return function callback() {
          // todo
        }
      }
    }
  },
  data() {
    return {
      pageIndex: ''
    }
  },
  computed: {
    indexs() {
      var left = 1
      var right = this.all
      var ar = []
      if (this.all >= 5) {
        if (this.cur > 3 && this.cur < this.all - 2) {
          left = this.cur - 2
          right = Number(this.cur) + 2
        } else {
          if (this.cur <= 5) {
            left = 1
            right = 5
          } else {
            right = this.all
            left = this.all - 4
          }
        }
      }
      while (left <= right) {
        ar.push(left)
        left++
      }
      return ar
    }
  },
  methods: {
    btnClick(page) {
      if (page !== this.cur) {
        this.callback(page)
      }
    },
    nextPage() {
      this.callback(this.cur + 1)
    },
    prevPage() {
      this.callback(this.cur - 1)
    },
    goPage(page) {
      if (Number(page) <= 0 || isNaN(Number(page))) {
        this.pageIndex = ''
        return
      }
      if (page > this.all) {
        this.callback(this.all)
        this.pageIndex = ''
        return
      }
      this.callback(page)
      this.pageIndex = ''
    }
  }
}
</script>

<style lang="less" scoped>
.topage {
  color: #666666;
  input {
    float: unset;
    border-right: 1px solid #ddd;
    margin-left: 10px;
    margin-right: 10px;
    height: 29px;
    outline: none;
  }
  span {
    display: inline-block;
    padding: 0 10px;
    height: 29px;
    background: #73D6CA;
    line-height: 29px;
    color: #fff;
    border-radius: 3px;
    cursor: pointer;
    margin-left: 10px;
  }
}
</style>
